import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['../../../global.scss', './loading.component.scss']
})
export class LoadingComponent {

  constructor(
  ) { }
}
